import React, { useState, useEffect, useCallback } from "react";
import { memo } from "react";
import { useSelector } from "react-redux";

const UpdateAdminRoles = ({ formik }) => {
  const selectedCustomer = useSelector(
    ({ admin: { updateadmin } }) => updateadmin
  );

  const [permissions, setPermissions] = useState(selectedCustomer.permissions);
  
  useEffect(() => {
    const initializedPermissions = selectedCustomer && Array.isArray(selectedCustomer.permissions) && selectedCustomer.permissions.map((p) => ({
      ...p,
      status: p.is_active ? 1 : 0,
    }));
    setPermissions(initializedPermissions);
  }, [selectedCustomer]);

  const handleChange = (index) => {
    setPermissions((prevPermissions) => {
      const updated = [...prevPermissions];
      const isChecked = !updated[index].is_active;

      updated[index] = {
        ...updated[index],
        is_active: isChecked,
        status: isChecked ? 1 : 0,
      };
        formik.setFieldValue("permissions", updated); 
      return updated;
    });
  };

  return (
    <div className="table-sec">
      <h4 className="pb-3"> Admin Roles</h4>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Permissions</th>
          </tr>
        </thead>
        <tbody>
          {permissions &&
            Array.isArray(permissions) &&
            permissions.map((role, index) => (
              <tr key={role.id}>
                <td>{role.title}</td>
                <td className="term-condition">
                  <input
                    type="checkbox"
                    checked={role.is_active}
                    onChange={() => handleChange(index)}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default memo(UpdateAdminRoles);
